import React from "react";
import SitemapLink, { IStreamLinkProps } from "./SitemapLink";

interface ISitemapColumnProps {
  section: {
    sectionTitle: string;
    sectionLinks: IStreamLinkProps[];
  };
}

const SitemapColumn = ({ section }: ISitemapColumnProps) => (
  <li data-testid="group-name">
    <p className="text-mobile-heading-6 md:text-desktop-heading-6 font-bold font-primary">
      {section.sectionTitle}
    </p>

    <nav>
      <ul className="flex flex-col mt-20">
        {window &&
          section.sectionLinks.map((link) => {
            if (link.label) {
              return <SitemapLink key={link.label} {...link} />;
            }
          })}
      </ul>
    </nav>
  </li>
);

export default SitemapColumn;
